import { round } from 'lodash';

const formatNumberAsMoney = value => {
  return round(value, 2);
};

export const getTotalPriceForSlotBasedSubscription = (subscriptionPrice, slotPrice, totalSlots) => {
  const unitAmount = formatNumberAsMoney(subscriptionPrice || 0);
  const slotsPrice = (totalSlots - 1) * slotPrice;

  return formatNumberAsMoney(slotsPrice + unitAmount);
};
